import { useState } from 'react';

import { Button, Form, Modal } from 'antd';

import { useMediaActionContext } from '../Context/MediaActioncontext';
import { MEDIA_MODAL_PROPS, MEDIA_OFFER_FORM_FIELDS, MEDIA_OFFER_VALIDATE_FIELDS } from '../helpers';

import MediaContentForm from './MediaContentForm';

function AddMediaContentModal() {
  const { func } = useMediaActionContext();
  const [open, setOpen] = useState(false);

  const form = Form.useFormInstance();

  const handleSave = () => {
    form.validateFields(MEDIA_OFFER_VALIDATE_FIELDS).then(() => {
      const values = form.getFieldsValue();
      func.handleSave(values);
      // Parent formla aynı instance paylaşıldığı için yalnızca modalın kendi alanları resetlenir
      // (aksi halde Madde Dosyası / Kimlik Kartı da sıfırlanır)
      form.resetFields(MEDIA_OFFER_FORM_FIELDS);
      setOpen(false);
    });
  };

  const handleCancel = () => {
    // Kapanışta da yalnızca modalın kendi alanları resetlenir (parent alanları korunur)
    form.resetFields(MEDIA_OFFER_FORM_FIELDS);
    setOpen(false);
  };

  return (
    <>
      <Button
        block
        type="dashed"
        onClick={() => setOpen(true)}
      >
        Medya Ekle
      </Button>
      <Modal
        {...MEDIA_MODAL_PROPS}
        open={open}
        title="Medya Ekle"
        onCancel={handleCancel}
        onOk={handleSave}
      >
        {/**
         * Modal, parent madde formu ile aynı instance'ı paylaşır (`form`) ama DOM'da
         * parent <form>'un DIŞINA (modal portal'ı) render edilir; bu yüzden buradaki
         * <Form layout="vertical"> iç içe <form> hatası yaratmaz ve Form.Item'lara
         * `.ant-form-vertical` hizalamasını kazandırır (SupervisorEdit ile aynı desen).
         */}
        <Form
          form={form}
          layout="vertical"
        >
          <MediaContentForm />
        </Form>
      </Modal>
    </>
  );
}
export default AddMediaContentModal;
